<template>
  <v-row class="justify-center">
    <v-col md="">
      <v-card flat>
        <v-card-title
          :class="BranchColor + ' white--text headline text-capitalize'"
        >
          <div flat class="d-print-none">
            <span class="mr-5">WHOLESALE</span>

            <!-- <v-spacer></v-spacer> -->
            <CartView SellType="wholesale" :StoreInfo="StoreInfo"></CartView>
          </div>
          <v-spacer></v-spacer>
          <p class="d-none d-print-block text-center">
            {{ `${UsersToken.UserBranch} (${UsersToken.BranchType})` }}
          </p>
          <v-spacer></v-spacer>
          <v-text-field
            solo
            dense
            class="mx-3 d-print-none"
            name="SearchText"
            label="SEARCH BOX"
            id="Searchid"
            v-model.trim="search"
          ></v-text-field>
          <!-- </v-toolbar> -->
          <v-spacer class="d-print-none"></v-spacer>
          <v-btn
            v-if="ProdoctsHoleSale.length"
            icon
            class="d-print-none"
            @click="PrintPage"
            small
            color="white"
          >
            <v-icon>fas fa-print</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          flat
          dense
          :loading="isLoading"
          :mobile-breakpoint="200"
          :headers="headers"
          :items="ProdoctsHoleSale"
          :search="search"
          :show-select="!hideFooter"
          v-model="selectedList"
          item-key="_id"
          :items-per-page="hideFooter ? ProdoctsHoleSale.length : 10"
          :item-class="
            item => (item.qty < 1 ? 'error darken-4 white--text' : '')
          "
        >
          <template class="d-print-none" v-slot:[`item.price`]="{ item }">
            <span class="d-print-none">
              {{ item.price.toLocaleString() }}
            </span>
          </template>

          <template v-slot:[`item.qty`]="{ item }">
            <!-- {{ item }} -->
            {{ parseInt(item.qty).toLocaleString() }}
            <span>{{ item.UnitType }}</span>
            <span class="error--text font-weight-bold">{{
              item | DecmalQTY
            }}</span>
          </template>
          <template class="d-print-none" v-slot:[`item.cart`]="{ item }">
            <addToCartCMP :key="item.product + item.code" :ItemObj="item">
            </addToCartCMP>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
// import { EventBus } from "@/main";
// import { delete } from 'vue/types/umd';
import { printTable } from "@/Mixins/printTable";
import printJS from "print-js";

export default {
  mixins: [printTable],
  components: {
    addToCartCMP: () => import("./Cart/AddToCart"),
    CartView: () => import("./Cart/CartView"),
  },
  props: {
    BranchColor: [String],
    StoreInfo: [Object],
    // headers: [Array],
  },
  data() {
    return {
      search: "",
      hideFooter: false,
      selectedList: [],
      headers: [
        // {
        //   text: "Order",
        //   align: "left",
        //   value: "code",
        //   class: "grey darken-3 white--text",
        // },
        {
          text: "Product",
          align: "left",
          value: "AccountName",
          class: "grey darken-3 white--text",
        },
        {
          text: "Item",
          align: "left",
          value: "InvName",
          class: "grey darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "grey darken-3 white--text",
        },

        {
          text: "Item Price",
          value: "price",
          class: "grey darken-3 white--text d-print-none",
        },
        // {
        //   text: "Item Cost",
        //   value: "cost",
        //   class: "grey darken-3 white--text d-print-none",
        // },
        {
          text: "Cart",
          value: "cart",
          align: "start",
          class: "grey darken-3 white--text d-print-none",
        },
      ],
    };
  },
  filters: {
    DecmalQTY(item) {
      // if (item.InvName == "4009" && item.code == "114=>115-41")
      //   console.log(item.toLocaleString());

      const unit = Math.round((item.qty - parseInt(item.qty)) * item.UnitQty);
      // if (item.code == "114=>115-41") console.log(item.qty.toFixed(4));
      if (unit > 0) return ` ${unit} PCS`;
    },
  },
  watch: {
    selectedList(v) {
      // console.log(v);
      this.$store.commit("RESET_CART");
      if (!v.length) return;
      v.forEach(ItemObj => {
        // eslint-disable-next-line no-unused-vars
        let { AccountName, invCateg, ...item } = ItemObj;
        this.$store.commit("DIRECT_CART", {
          ...item,
          // qty: this.QTY,
          // price: this.PRICE,
        });
      });
    },
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "getProducts",
      "UsersToken",
      "getGroupedProducts",
    ]),
    ProdoctsHoleSale() {
      if (!this.getProducts.length) return [];
      if (this.hideFooter) {
        let ProdectObj = this.getProducts.reduce((prods, item) => {
          let { qty } = prods[item.InvName] || { qty: 0.0 };

          // if (item.InvName === "FZ28") console.log(item);
          // console.log(item);
          prods[item.InvName] = {
            InvName: item.InvName,
            qty: parseFloat((qty + item.qty).toFixed(2)),
            AccountName: item.AccountName,
            UnitType: item.UnitType,
            UnitQty: item.UnitQty,
            price: item.price,
            cost: item.cost,
            Formatprice: item.price && item.price.toLocaleString(),
            Formatcost: item.cost && item.cost.toLocaleString(),
            totalCost: (
              item.cost * parseFloat(qty + item.qty)
            ).toLocaleString(),
            totalPrice: (
              item.price * parseFloat(qty + item.qty)
            ).toLocaleString(),
          };
          return prods;
        }, {});
        // console.log(ProdectObj);
        return Object.keys(ProdectObj)
          .map(key => {
            return ProdectObj[key];
          })
          .sort((a, b) => (a.InvName < b.InvName ? -1 : 1));
      }
      return this.getGroupedProducts.filter(item => item.qty >= 1);
    },
    AvailibleBalanceArray() {
      return [
        {
          Amount: this.ProdoctsHoleSale.reduce((total, item) => {
            // console.log(item.cost);
            return (total += item.cost * item.qty);
          }, 0),
          AmountType: "Cost",
        },
        {
          Amount: this.ProdoctsHoleSale.reduce((total, item) => {
            // console.log(item.cost);
            return (total += item.price * item.qty);
          }, 0),
          AmountType: "Price",
        },
      ];
    },
  },
  methods: {
    async PrintPage() {
      this.hideFooter = true;

      const prHeader = [
        { value: "index", text: "#" },
        ...this.headers.filter(
          head =>
            head.text !== "Ref" &&
            head.text != "Cart" &&
            head.text !== "Order" &&
            head.text !== "Product" &&
            head.text !== "Item Price"
        ),
        { value: "Formatcost", text: "Cost" },
        { value: "Formatprice", text: "Price" },
        { value: "totalCost", text: "T-Cost" },
        { value: "totalPrice", text: "T-Price" },
      ];
      let myTitle = `${this.UsersToken.UserBranch} (${this.UsersToken.BranchType})`;
      const myPrintTable = this.PrintReport(
        this.ProdoctsHoleSale,
        prHeader,
        myTitle.toUpperCase()
      );

      printJS({
        printable: myPrintTable,
        type: "html",
        style: this.CustomStyle("#003180"),
        repeatTableHeader: false,
      });
      this.hideFooter = false;
    },
  },
  created() {
    this.$store.commit("CLEAR_CART_IF");
    // console.log(this.getGroupedProducts.filter(item => item.codes.length > 2));
  },
};
</script>
